export const BOOLEAN_SUBSCRIPTION_KEYS = [
  'sms',
  'voice',
  'email',
  'push',
  'offer',
  'performance',
  'coachingEmail',
  'coachingVoice',
  'coachingSms',
  'coachingPush',
  'paymentEmail',
  'remindersEmail',
  'remindersPush',
  'alertRuleEmail',
] as const;
export type BooleanSubscriptionKey = (typeof BOOLEAN_SUBSCRIPTION_KEYS)[number];
